import { render, staticRenderFns } from "./steel_type.vue?vue&type=template&id=f2334872&scoped=true"
import script from "./steel_type.vue?vue&type=script&lang=js"
export * from "./steel_type.vue?vue&type=script&lang=js"
import style0 from "./steel_type.vue?vue&type=style&index=0&id=f2334872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2334872",
  null
  
)

export default component.exports